export var DropdownType;
(function (DropdownType) {
    DropdownType["Primary"] = "primary";
    DropdownType["Secondary"] = "secondary";
})(DropdownType || (DropdownType = {}));
export var DropdownAlignment;
(function (DropdownAlignment) {
    DropdownAlignment["Left"] = "left";
    DropdownAlignment["Right"] = "right";
    DropdownAlignment["Auto"] = "auto";
})(DropdownAlignment || (DropdownAlignment = {}));
